import styled from 'styled-components'
import { useContext } from 'react'
import { OrderItemsContext } from '../context/OrderItemsContext'
import { OrderDataContext } from '../context/OrderDataContext'
import { TranslationContext } from '../context/TranslationContext'
import { AvailableDatesContext, LocationsContext } from '../context/AvailableDatesContext'
import { ReservationContext } from '../context/ReservationContext'
import { getHours, format } from 'date-fns'
import { Text } from '@chakra-ui/react'
import Api from '../api/api'

function Heading ({ page }) {
    const { orderItems, setOrderItems } = useContext(OrderItemsContext)
    const { order, setOrder } = useContext(OrderDataContext)
    const { translations } = useContext(TranslationContext)
    const { availableDates, setAvailableDates } = useContext(AvailableDatesContext)
    const { locations } = useContext(LocationsContext)
    const { reservation } = useContext(ReservationContext)
    const renderHi = () => {
        const currentHour = getHours(new Date())

        if (currentHour > 23) {
            return translations.welcome_1
        } else if (currentHour > 5 && currentHour < 12) {
            return translations.welcome_2
        } else if (currentHour > 12 && currentHour < 18) {
            return translations.welcome_3
        } else {
            return translations.welcome_4
        }
    }

    const onSelect = event => {
        const date = event.target.value;
        Api.log({
            reservation: reservation.code,
            type: 'menu-reservation',
            action: 'Date change',
            orderDate: order.date,
            additionalData: JSON.stringify({
                changeTo: event.target.value,
            })
        })
        setOrderItems({})
        setOrder((currentOrder) => ({
            ...currentOrder,
            ...{
                date: date,
                time: null,
                location: locations[0]?.location,
                comment: null,
                price: 0,
                id: null,
            }
        }))
    }
    const selectStyle = {
        backgroundColor: '#3F4041',
        color: 'white',
        padding: '3px 5px',
        border: 'none',
        fontSize: '15px',
        WebkitAppearance: 'button',
        outline: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
    }
    const renderDateSelector = () => {
        if (availableDates.length > 1) {
            return <select style={selectStyle} onChange={onSelect} defaultValue={order.date}>
                {availableDates.map(date => {
                    return <option key={date} value={date} >{date}</option>
                })}
            </select>
        }
        return !order.day ? <strong>{order.date}</strong> : <><strong>{order.day}</strong> ({order.date})</>
    }

    if (page === 'time' || page === 'menu') {
        return <>
            <h1>{renderHi()}, {reservation.name}!</h1>
            <p>
                {order.id ? translations.change_order_start : translations.create_order_start}
                {' '+translations.breakfast_order_for} <span className='no-wrap'>
                    {renderDateSelector()}</span><br />
                <Notice>{translations.breakfast_create_notice}</Notice>
            </p>
        </>
    }

    const locationMessage = () => (locations.find(location => location.location === order.location)?.location || '').toLowerCase()

    if (page === 'cooking') {
        if (order.status === 'completed') {
            return <>
                <h1>{renderHi()}, {reservation.name}!</h1>
                <p>
                    {translations.you_breakfast_order_for} <span className='no-wrap'>
                        {renderDateSelector()}</span> {translations.was} <span style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '20px' }}>{translations.completed}</span><br />
                </p>
            </>
        }
        if (order.status === 'preparing' || order.status === 'ready') {
            return <>
                <h1>{renderHi()}, {reservation.name}!</h1>
                <p>
                    {translations.kitchen_already_preparing_start} <span style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '20px' }}>{translations.preparing}</span> {translations.your_order_for} <span className='no-wrap'>
                        {renderDateSelector()}</span><br />
                    {translations.see_you_soon} <strong>{order.time} {translations[locationMessage()]}</strong> {String.fromCodePoint(0x1F924)}
                </p>
            </>
        }

        return <>
            <h1>{renderHi()}, {reservation.name}!</h1>
            <p>
                {translations.kitchen_received_your_order} <span className='no-wrap'>
                    {renderDateSelector()}</span><br />
                {translations.see_you_at} <strong>{order.time} {translations[locationMessage()]}</strong> {String.fromCodePoint(0x1F924)}
                {/* <Notice>Booking breakfast in advance will let us serve you better & save your time.</Notice> */}
            </p>
        </>
    }


    if (orderItems) {
        return <>
            <h1>{translations.good_choice} {reservation.name}!</h1>
            <p>
                {translations.please_review}{' '}
                {order.id && <strong>{translations.updaed} </strong>}
                {translations.breakfast_order_for} <span
                    className='no-wrap'>{!order.day ? <strong>{order.date}</strong> : <><strong>{order.day}</strong> ({order.date})</>}</span>
                {<>{' '}@ {order.time} {translations[locationMessage()]}</>}
            </p>
        </>
    } else {
        return <h1>{renderHi()}, {reservation.name}!</h1>
    }
}


const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`;

const Items = styled.div`

`

const GroupTitleWrapper = styled.div`
    position: relative;
    height: 30px;
    // margin: 20px 0 10px 0;
    background: #fff;
`

const GroupTitle = styled.div`
    text-align: center;
    text-transform: uppercase;
    color: #AE996F;
    line-height: 25px;

    .sticky {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
    }

    span {
        display: inline-block;
        background: #fff;
        padding: 0 10px;
        font-size: 10px;
        z-index: 1;
        position: relative;
    }

    &:after {
        content: "";
        position: absolute;
        display: block;
        height: 1px;
        background: #AE996F;
        left: 10px;
        right: 10px;
        top: 13px;
        opacity: 0.3;
    }
`

const Notice = styled.span`
    font-size: 14px;
    opacity: 0.6;
    display: block;
    margin-top: 5px;
`

export default Heading;
